(function () {
  'use strict';

  function start() {
    var root = document.getElementById('qsd-tracking');
    if (!root || root.dataset.qsd17trackInitialized) return;
    var form = root.querySelector('[data-qsd-tracking-form]');
    var input = root.querySelector('[data-qsd-tracking-number]');
    var button = form && form.querySelector('button[type="submit"]');
    var status = root.querySelector('[data-qsd-tracking-status]');
    var result = root.querySelector('[data-qsd-tracking-result]');
    if (!form || !input || !button || !status || !result) return;
    root.dataset.qsd17trackInitialized = 'true';

    var providerPromise = null;
    var loading = false;
    var opening = false;
    var frameTimeout = null;
    var providerUrl = 'https://www.17track.net/externalcall.js';

    function message(key) {
      status.textContent = root.getAttribute('data-message-' + key) || '';
    }

    function resetResults() {
      window.clearTimeout(frameTimeout);
      frameTimeout = null;
      opening = false;
      result.textContent = '';
      result.hidden = true;
    }

    function providerLanguage() {
      // The storefront's existing language controller resolves browser and
      // manual choices. Use its selected UI language, never a fresh guess.
      var language = String((window.QSDLocale && window.QSDLocale.language) || document.documentElement.getAttribute('data-qsd-lang') || document.documentElement.lang || root.dataset.locale || 'en').toLowerCase().replace(/_/g, '-');
      if (/^zh-(?:hant|tw|hk|mo)(?:-|$)/.test(language)) return 'zh-hk';
      if (/^zh(?:-|$)/.test(language)) return 'zh-cn';
      return 'en';
    }

    function hasProvider() {
      return window.YQV5 && typeof window.YQV5.trackSingle === 'function';
    }

    function loadProvider() {
      if (hasProvider()) return Promise.resolve(window.YQV5);
      if (providerPromise) return providerPromise;
      providerPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        var settled = false;
        var timeout;
        function finish(error) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeout);
          script.onload = null;
          script.onerror = null;
          if (error) {
            script.remove();
            providerPromise = null;
            reject(error);
          } else {
            resolve(window.YQV5);
          }
        }
        script.async = true;
        script.src = providerUrl;
        script.onload = function () {
          finish(hasProvider() ? null : new Error('17TRACK API unavailable'));
        };
        script.onerror = function () { finish(new Error('17TRACK script unavailable')); };
        timeout = window.setTimeout(function () { finish(new Error('17TRACK script timed out')); }, 12000);
        document.head.appendChild(script);
      });
      return providerPromise;
    }

    function prepareFrames() {
      var frames = result.querySelectorAll('iframe');
      Array.prototype.forEach.call(frames, function (frame) {
        if (frame.dataset.qsdTrackingFrame) return;
        frame.dataset.qsdTrackingFrame = 'true';
        frame.style.width = '100%';
        frame.style.minWidth = '260px';
        frame.style.border = '0';
        frame.title = root.getAttribute('data-frame-title');
        frame.addEventListener('error', function () {
          if (result.contains(frame)) message('error');
        });
      });
      if (opening && frames.length) {
        window.clearTimeout(frameTimeout);
        frameTimeout = null;
        opening = false;
        message('opened');
      }
    }

    if (window.MutationObserver) new MutationObserver(prepareFrames).observe(result, { childList: true, subtree: true });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (loading) return;
      var raw = input.value;
      var number = raw.trim();
      if (/[\u0000-\u001f\u007f]/.test(raw) || !/^[A-Za-z0-9-]{6,60}$/.test(number) || !/[A-Za-z0-9]/.test(number)) {
        resetResults();
        input.setAttribute('aria-invalid', 'true');
        message(number ? 'invalid' : 'empty');
        input.focus();
        return;
      }
      resetResults();
      input.setAttribute('aria-invalid', 'false');
      loading = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      message('loading');
      loadProvider().then(function (provider) {
        result.hidden = false;
        opening = true;
        message('opening');
        frameTimeout = window.setTimeout(function () {
          if (!opening) return;
          resetResults();
          message('error');
        }, 8000);
        provider.trackSingle({
          YQ_ContainerId: result.id,
          YQ_Height: 560,
          YQ_Fc: '0',
          YQ_Lang: providerLanguage(),
          YQ_Num: number
        });
        prepareFrames();
      }).catch(function () {
        resetResults();
        message('error');
      }).finally(function () {
        loading = false;
        button.disabled = false;
        form.setAttribute('aria-busy', 'false');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
